import React, { useState } from 'react';
import { Box, Drawer } from '@mui/material';
import { SidebarHeader } from './SidebarHeader';

const drawerWidth = 485;

interface SidebarDrawerProps {
  open: boolean;
  onClose?: () => void;
  title?: string;
  onSave?: (e: React.FormEvent<HTMLFormElement>) => void;
  loading?: boolean;
  children: React.ReactNode | React.ReactNode[];
}

export const SidebarDrawer = ({
  open,
  onClose = undefined,
  onSave = undefined,
  title = '',
  loading = false,
  children,
}: SidebarDrawerProps) => {
  const [inputHasChanged, setInputHasChanged] = useState(false);

  React.useEffect(() => {
    setInputHasChanged(false);
  }, [open]);

  const handleSave = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSave?.(e);
  };

  const handleClickOutside = () => {
    if (!inputHasChanged) {
      onClose?.();
    }
  };

  const handleCloseButtonClick = () => {
    onClose?.();
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClickOutside}
      ModalProps={{ disableEnforceFocus: true }}
    >
      <Box
        sx={{
          width: {
            xs: '100%',
            md: drawerWidth,
          },
        }}
      >
        <form onSubmit={handleSave} onChange={() => setInputHasChanged(true)}>
          {title && (
            <SidebarHeader
              title={title}
              onSave={handleSave}
              loading={loading}
              onClose={handleCloseButtonClick}
            />
          )}
          <Box sx={{ padding: 2 }}>{children}</Box>
        </form>
      </Box>
    </Drawer>
  );
};
